import {config, http} from './__http';

export default {

    // NOTIFICATION
    getNotifications(notifications, params) {
        http.get(config.baseUrl()+'/notification').then(response => {
            notifications(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    getAllNotifications(notifications, params) {
        http.get(config.baseUrl()+'/notification/all').then(response => {
            notifications(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    createNotification(notification, params) {
        http.post(config.baseUrl()+'/notification', params).then(response => {
            notification(response.data);
        }).catch(e => {
            notification(e.response);
        });
    },
    getNotification(notification, id) {
        http.get(config.baseUrl()+'/notification/'+id).then(response => {
            notification(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    updateNotification(notification, params) {
        http.put(config.baseUrl()+'/notification/'+params.Id, params).then(response => {
            notification(response.data)
        }).catch(e => {
            notification(e.response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/Notification.js